/**
 * 自动生成， 请不要手工修改！
 */

export enum ServiceQuotaType {
  FREE,
  FREE_WITH_LIMIT,
  DISCOUNT,
}
